import { KpiPeriodType } from '../kpi/kpi'

export function getISOWeek(date: Date): number {
  const tmp = new Date(date.getTime())
  tmp.setHours(0, 0, 0, 0)
  tmp.setDate(tmp.getDate() + 4 - (tmp.getDay() || 7))
  const yearStart = new Date(tmp.getFullYear(), 0, 1)
  const weekNo = Math.ceil(((tmp.getTime() - yearStart.getTime()) / 86400000 + 1) / 7)
  return weekNo
}

function getMonday(year: number, week: number): Date {
  const simple = new Date(year, 0, 1 + (week - 1) * 7)
  const dow = simple.getDay()
  const ISOweekStart = simple
  if (dow <= 4) ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1)
  else ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay())
  return ISOweekStart
}

export function normalizePeriodDate(valueDate: string, periodType: KpiPeriodType): Date {
  switch (periodType) {
    case KpiPeriodType.DAY:
      return new Date(valueDate + 'T00:00:00.000Z')
    
    case KpiPeriodType.WEEK: {
      // "2024-W03" → 해당 주의 월요일
      const [year, week] = valueDate.split('-W')
      return getMonday(parseInt(year), parseInt(week))
    }
    
    case KpiPeriodType.MONTH:
      return new Date(valueDate + '-01T00:00:00.000Z')
    
    case KpiPeriodType.QUARTER: {
      // "2024-Q1" → 해당 분기 시작일
      const [year, quarter] = valueDate.split('-Q')
      const month = (parseInt(quarter) - 1) * 3 + 1
      return new Date(`${year}-${month.toString().padStart(2, '0')}-01T00:00:00.000Z`)
    }
    
    case KpiPeriodType.YEAR:
      return new Date(valueDate + '-01-01T00:00:00.000Z')
    
    case KpiPeriodType.RANGE: {
      // "2024-01-01~2024-01-31" → 시작일 사용
      const startDate = valueDate.split('~')[0]
      return new Date(startDate + 'T00:00:00.000Z')
    }
    
    case KpiPeriodType.ALLTIME:
      return new Date('1900-01-01T00:00:00.000Z') // 고정 기준점
      
    default:
      return new Date(valueDate + 'T00:00:00.000Z')
  }
}

export function getDefaultValueDate(periodType: KpiPeriodType, mode: 'current' | 'last' = 'current'): string {
  const now = new Date()
  if (mode === 'last') {
    switch (periodType) {
      case KpiPeriodType.DAY: {
        const d = new Date(now)
        d.setDate(d.getDate() - 1)
        return d.toISOString().slice(0, 10)
      }
      case KpiPeriodType.MONTH: {
        const d = new Date(now)
        d.setMonth(d.getMonth() - 1)
        return d.toISOString().slice(0, 7)
      }
      case KpiPeriodType.QUARTER: {
        let year = now.getFullYear()
        let quarter = Math.floor(now.getMonth() / 3)
        if (quarter === 0) {
          year -= 1
          quarter = 4
        }
        return `${year}-Q${quarter}`
      }
      case KpiPeriodType.WEEK: {
        const d = new Date(now)
        d.setDate(d.getDate() - 7)
        const year = d.getFullYear()
        const week = getISOWeek(d)
        return `${year}-W${week}`
      }
      case KpiPeriodType.ALLTIME:
        return 'ALLTIME'
      default: {
        const d = new Date(now)
        d.setDate(d.getDate() - 1)
        return d.toISOString().slice(0, 10)
      }
    }
  } else {
    switch (periodType) {
      case KpiPeriodType.DAY:
        return now.toISOString().slice(0, 10)
      case KpiPeriodType.MONTH:
        return now.toISOString().slice(0, 7)
      case KpiPeriodType.QUARTER: {
        const year = now.getFullYear()
        const quarter = Math.floor(now.getMonth() / 3) + 1
        return `${year}-Q${quarter}`
      }
      case KpiPeriodType.WEEK: {
        const year = now.getFullYear()
        const week = getISOWeek(now)
        return `${year}-W${week}`
      }
      case KpiPeriodType.ALLTIME:
        return 'ALLTIME'
      default:
        return now.toISOString().slice(0, 10)
    }
  }
}
